import apiClient from "./api";
const USUARIO_API_BASE_URL = "/usuarios";
class UsuarioService {
  getUsuarios() {
    return apiClient.get(USUARIO_API_BASE_URL);
  }
  createUsuario(usuario) {
    return apiClient.post(USUARIO_API_BASE_URL, usuario);
  }
  async getUsuarioById(usuarioId) {
    const response = await apiClient.get(USUARIO_API_BASE_URL + "/" + usuarioId);
    const user = response.data;
    return user;
  }
  async getUltimoUsuario() {
    const response = await apiClient.get(USUARIO_API_BASE_URL)
    const usuarios = response.data;
    const ultimoUsuario = usuarios.slice(-1)[0];
    return ultimoUsuario;
  }
  updateUsuario(usuario, usuarioId) {
    return apiClient.put(`${USUARIO_API_BASE_URL}/${usuarioId}`, { usuario });
  }
  deleteUsuario(usuarioId) {
    return apiClient.delete(USUARIO_API_BASE_URL + "/" + usuarioId);
  }
  async getLogin(usuario, contrasenia) {
    try {
      const response = await apiClient.post(`${USUARIO_API_BASE_URL}/validar`, { usuario, contrasenia });
      const user = response.data.usuario;
      return user;
    } catch (error) {
      console.error(error);
    }
  }

  async cambiarUsuario(usuarioId, nuevoUsuario) {
    try {
      const response = await apiClient.put(`${USUARIO_API_BASE_URL}/cambiarUsuario/${usuarioId}`, { nuevoUsuario });
      return response.data;
    } catch (error) {
      console.error(error);
      return { estatus: "ERROR", mensaje: "Error de conexión al cambiar el usuario" };
    }
  }

  async cambiarContrasenia(usuarioId, nuevaContrasenia) {
    try {
      const response = await apiClient.put(`${USUARIO_API_BASE_URL}/cambiarContrasena/${usuarioId}`, { nuevaContrasenia });
      return response.data;
    } catch (error) {
      console.error(error);
      return { estatus: "ERROR", mensaje: "Error de conexión al cambiar la contraseña" };
    }
  }

  cambiarSucursal(idUsuario, idSucursal) {
    return apiClient.put(`/usuarios/cambiarSucursal/${idUsuario}`, { idSucursal });
  }

}
export default new UsuarioService();